import { render, staticRenderFns } from "./getpassSuc.vue?vue&type=template&id=7d5a6d45&scoped=true"
import script from "./getpassSuc.vue?vue&type=script&lang=js"
export * from "./getpassSuc.vue?vue&type=script&lang=js"
import style0 from "./getpassSuc.vue?vue&type=style&index=0&id=7d5a6d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a6d45",
  null
  
)

export default component.exports